import { connect } from 'react-redux';
import {
  getMegaMenuActiveLevel,
  getMegaMenuMaxLength,
  getMegaMenuMenus,
  megaMenuIsOpen,
  getExperienceFragmentKeyForActiveMenuItem,
} from 'redux/modules/page/selectors/mega-menu';
import { setMegaMenu } from 'redux/modules/page/actions/set-mega-menu';
import { setMegaMenuState } from 'redux/modules/page/actions/set-mega-menu-state';
import { getIsTaxonomyLoading, getMenuCategoryById } from 'redux/modules/taxonomy/selectors';
import MegaMenu from './Menus';

export default connect(
  state => {
    const activeLevel = getMegaMenuActiveLevel(state);
    const menus = getMegaMenuMenus(state);

    return {
      activeLevel,
      isOpen: megaMenuIsOpen(state),
      loading: getIsTaxonomyLoading(state),
      maxMenus: getMegaMenuMaxLength(state),
      menus,
      experienceFragmentKeyForActiveMenuItem: getExperienceFragmentKeyForActiveMenuItem(state),
      category: getMenuCategoryById(state, menus[activeLevel]?.id),
      parentCategory: getMenuCategoryById(state, menus[activeLevel - 1]?.id),
    };
  },
  {
    onToggle: setMegaMenuState,
    setMegaMenu,
  },
)(MegaMenu);
